export default __webpack_public_path__ + "static/media/RTA_WEB.da813651.svg";